import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "../../../lib/hooks/useNavigate";
import { ResetPasswordContainer } from "../../features/reset_password";
import useResetPasswordStore, {
  onResetPassword,
} from "../../features/reset_password/redux/store";
import { HeaderTemplate } from "../../template";
import { Base } from "../../template/style";
import { Modal } from "../../ui";
import { Footer } from "../../ui/footer/Footer";

export const ResetPassword: React.FC = () => {
  const { tenant_code, code } = useParams();
  const enabled = useResetPasswordStore((state) => state.enabled);
  const navigate = useNavigate();
  const [isComplete, setIsComplete] = useState<boolean>(false);

  const onComplete = useCallback(() => {
    setIsComplete(true);
  }, []);

  const onClose = useCallback(() => {
    setIsComplete(false);
    navigate("/login");
  }, []);

  return (
    <Base>
      <HeaderTemplate>
        <ResetPasswordContainer />
        <Modal
          isShow={isComplete}
          title={"パスワードを変更しました。"}
          subTitle={""}
          contents={""}
          onClose={onClose}
        />
      </HeaderTemplate>
      <Footer
        buttonText="決定"
        onClickButton={() => {
          onResetPassword(tenant_code ?? "", code ?? "")
            .then(onComplete)
            .catch((e) => {
              /* nothing to do */
            });
        }}
        buttonDisabled={!enabled}
      />
    </Base>
  );
};
